import { fontSizes } from '../../../../constants/constants';
import dynamicfunction from '../../../../utils/dynamicfunction';
import { ErrorText, InputField, RadioButton, RowView, Text } from '../index';
import CustomInput from '../../../../components/CustomInput';
const NonUsNotFinancialThen = ({
  getContent,
  values,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  touched,
  optionsYesOrNO,
  errors,
  formatGIIN,
}) => {
  const { TextWeight } = dynamicfunction();

  return (
    <>
      <div className='pt-3 sm:pt-5'>
        <Text
          text={getContent('if_non_us_not_financial_then')}
          size={fontSizes.h18}
          isTruncate={false}
          weight={TextWeight.medium}
          className='block'
          isRequired={true}
        />
      </div>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_excepted_non_financial_non_us')}
            value={values?.exceptedNonFinancialUsEntity}
            onChange={(e) => {
              setFieldValue('exceptedNonFinancialUsEntity', e);
              setFieldTouched('exceptedNonFinancialUsEntity', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.exceptedNonFinancialUsEntity ? errors?.exceptedNonFinancialUsEntity : '')} />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_active_non_financial_non_us')}
            value={values?.activeNonFinancialNonUsEntity}
            onChange={(e) => {
              setFieldValue('activeNonFinancialNonUsEntity', e);
              setFieldTouched('activeNonFinancialNonUsEntity', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.activeNonFinancialNonUsEntity ? errors?.activeNonFinancialNonUsEntity : '')} />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_direct_nffe')}
            value={values?.directOrSponsoredReportingNonFinancialForeignEntity}
            onChange={(e) => {
              setFieldValue(
                'directOrSponsoredReportingNonFinancialForeignEntity',
                e
              );
              setFieldTouched(
                'directOrSponsoredReportingNonFinancialForeignEntity',
                false
              );
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(
              touched?.directOrSponsoredReportingNonFinancialForeignEntity ? errors?.directOrSponsoredReportingNonFinancialForeignEntity : ''
            )}
          />
        </div>
      </RowView>
      
      {
        Number(values?.directOrSponsoredReportingNonFinancialForeignEntity) === 1 && (
      <div className='pt-3 sm:pt-5'>
        <CustomInput
                          isRounded
                          isRequired={true}
          label={getContent('giin')}
          value={formatGIIN(
            values?.giinDirectOrSponsoredReportingNonFinancialForeignEntity
          )}
          onChange={(e) => {
            setFieldValue(
              'giinDirectOrSponsoredReportingNonFinancialForeignEntity',
              e.target.value
            );
            setFieldTouched(
              'giinDirectOrSponsoredReportingNonFinancialForeignEntity',
              true, false
            );
          }}
          maxLength={19}
          errorMessage={getContent(
            touched?.giinDirectOrSponsoredReportingNonFinancialForeignEntity ? errors?.giinDirectOrSponsoredReportingNonFinancialForeignEntity : ''
          )}
        />
      </div>
      )
      }
    </>
  );
};
export default NonUsNotFinancialThen;
